<template>
  <div id="app" class="components-layout-demo-basic">
    <a-layout style="min-height: 100vh;background-color: rgb(249, 249, 254);">
      <a-layout-header id="flashHeader" :style="{ zIndex: 1, width: '100%', padding: '0px', textAlign: 'right', background: 'white', position: 'fixed'}">
        <Header/>
      </a-layout-header>
      <a-layout-content id="flashMain" :style="{flex: 1,background: 'rgb(244, 244, 255)', marginTop: '64px'}">
        <router-view/>
      </a-layout-content>
      <a-layout-footer id="flashFooter" :style="{height:'124px', background: 'rgb(32, 45, 49)', width: '100%', color: 'white'}">
        <a-row>
          <span style="cursor: pointer; text-decoration: underline" @click="$router.push('/privacyPolicy')">Privacy Policy</span>
          <span style="margin: 0 10px">|</span>
          <span style="cursor: pointer; text-decoration: underline" @click="$router.push('/terms-of-service')">Terms of Service</span>
<!--          <span style="margin: 0 10px">|</span>-->
<!--          <span>Phone: 65-84955578 </span>-->
<!--          <span style="margin: 0 10px">|</span>-->
<!--          <span>Address: 133 NEW BRIDGE ROAD #10-03 CHINATOWN POINT SINGAPORE (059413)</span>-->
        </a-row>
        <a-divider></a-divider>
        © 2024 AIConverse. All rights reserved.
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import Header from '@/components/header/Header.vue'
export default {
  components: {
    Header
  },
  computed: {

  },
  data() {
    return {

    }
  },
  methods: {

  },
}
</script>

<style>
#app {
  /*font-family: '阿里巴巴普惠体', '仓耳渔阳体 W05', Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--default-text-color);
  overflow: auto;
  //height: 100%;
  
}
.components-layout-demo-basic {
   text-align: center;
 }
.components-layout-demo-basic .ant-layout-header,
.components-layout-demo-basic .ant-layout-footer {
  background: #7dbcea;
  color: #fff;
}
</style>
